import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import ToastNotification from '../ToastNotification/ToastNotification';
import RegisterPassword5 from '../RegisterPassword5/RegisterPassword5';

const RegisterPassword4 = () => {
    const [otpCode, setOtpCode] = useState('');
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(false);
    
    // Configuração do Contador (300 segundos = 5 minutos)
    const [secondsLeft, setSecondsLeft] = useState(300);
    const [isTimerActive, setIsTimerActive] = useState(true);

    // Estado para o Toast
    const [toast, setToast] = useState({ show: false, message: '', type: '' });

    // Estado utilizado para controlar o avanço para a próxima fase
    const [isValidated, setIsValidated] = useState(false); 

    const showMessage = (msg, type) => {
        setToast({ show: true, message: msg, type: type });
        setTimeout(() => setToast(prev => ({ ...prev, show: false })), 5000);
    };

    // Efeito para decodificar o token e pegar o userId
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserId(decoded.userId || decoded.sub);
            } catch (error) {
                console.error("Erro ao decodificar token:", error);
                showMessage("Sessão expirada. Reinicie o processo.", "error");
            }
        }
    }, []);

    // Lógica do Cronômetro Regressivo
    useEffect(() => {
        let timer;
        if (isTimerActive && secondsLeft > 0) {
            timer = setInterval(() => {
                setSecondsLeft((prev) => prev - 1);
            }, 1000);
        } else if (secondsLeft === 0) {
            setIsTimerActive(false);
            showMessage("O código expirou. Solicite um novo envio.", "error");
        }
        return () => clearInterval(timer);
    }, [isTimerActive, secondsLeft]);

    // Formata segundos em MM:SS
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (secondsLeft <= 0) {
            showMessage("Tempo esgotado. Por favor, tente novamente.", "error");
            return;
        }

        setLoading(true);
        const token = localStorage.getItem('token');

        try {
            // Ambientes - Development: localhost:8443 - Homologation: phantomtech.com.br 
            const response = await axios.post(
                `https://phantomtech.com.br/AutomaTech/api/credentials/setOtpCodeByTarget`,
                {
                    userId: parseInt(userId),
                    otpTarget: "EMAIL_VALIDATION",
                    otpCode: otpCode.toUpperCase().trim()
                },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (response.status === 200) {
                showMessage(response.data.message || "Código validado com sucesso!", "success");
                setIsTimerActive(false);
                // Aqui ocorre o disparo para o timer e prosseguimento para o Passo 5 após o sucesso
                setTimeout(() => {
                    setIsValidated(true); 
                }, 2000);
                
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Código inválido ou erro no servidor.';
            showMessage(errorMsg, 'error');
        } finally {
            setLoading(false);
        }
    };

    // LÓGICA + COMANDO PARA TROCA DE TELA
            if (isValidated) {
                return <RegisterPassword5 />;
            }

    return (
        <div className="container vh-100 d-flex justify-content-center align-items-center">
            <ToastNotification
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ ...toast, show: false })}
            />

            <div className="col-12 col-md-8 col-lg-5">
                <div className="card shadow-sm border-primary">
                    <div className="card-body p-4">
                        
                        <h3 className="card-title text-center mb-1">Cadastramento de Senha - Passo 4</h3>
                        <p className="text-center text-muted mb-4">Verificação de Segurança: cheque sua caixa de e-mail informada no passo anterior e localize o código que enviamos para você</p>

                        {/* Display do Contador */}
                        <div className="text-center mb-4">
                            <div className={`display-6 fw-bold ${secondsLeft < 60 ? 'text-danger' : 'text-primary'}`}>
                                {formatTime(secondsLeft)}
                            </div>
                            <small className="text-muted">O código expira em breve</small>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <label className="form-label fw-bold small text-secondary">
                                    Digite abaixo o Código Recebido Em Seu E-mail
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-lg text-center fw-bold"
                                    placeholder="Ex: 92TG4E"
                                    style={{ letterSpacing: '4px', textTransform: 'uppercase' }}
                                    value={otpCode}
                                    onChange={(e) => setOtpCode(e.target.value)}
                                    maxLength={10}
                                    required
                                />
                            </div>

                            <div className="d-grid mt-4">
                                <button 
                                    type="submit" 
                                    className="btn btn-primary btn-lg fw-bold shadow-sm"
                                    disabled={loading || secondsLeft === 0}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Validando...
                                        </>
                                    ) : 'ENVIAR'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="text-center mt-3">
                    <button 
                        className="btn btn-link btn-sm text-decoration-none text-muted"
                        onClick={() => window.location.reload()}
                        disabled={loading}
                    >
                        <i className="bi bi-arrow-clockwise me-1"></i>
                        Não recebeu o código? Reenviar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RegisterPassword4;